<template>
  <g>
    <path
      d="M11.15 3.40017L7.43 9.48017C7.02 10.1402 7.5 11.0002 8.28 11.0002H15.71C16.49 11.0002 16.97 10.1402 16.56 9.48017L12.85 3.40017C12.46 2.76017 11.54 2.76017 11.15 3.40017Z"
    />
    <path
      d="M17.5 22.0002C19.9853 22.0002 22 19.9855 22 17.5002C22 15.0149 19.9853 13.0002 17.5 13.0002C15.0147 13.0002 13 15.0149 13 17.5002C13 19.9855 15.0147 22.0002 17.5 22.0002Z"
    />
    <path
      d="M4 21.5002H10C10.55 21.5002 11 21.0502 11 20.5002V14.5002C11 13.9502 10.55 13.5002 10 13.5002H4C3.45 13.5002 3 13.9502 3 14.5002V20.5002C3 21.0502 3.45 21.5002 4 21.5002Z"
    />
  </g>
</template>
